import {
	SimpleDialog,
	SimpleDialogModel,
} from '~/components/dialog/simple-dialog';
import { ShortcutKey } from '~/constants';
import { Key } from '~/utils/key';
import { KeyboardShortcut } from '~/utils/keyboard-shortcut';

/**
 * Use this dialog when you want an SimpleDialog over the top of another dialog (eg dirty form, delete notes).
 * Associated HTML file includes keybindings that replace the in built Aurelia dialog
 * Enter/Escape keyboard shortcuts. By overriding this functionality, pressing enter/escape
 * on the parent dialog will not propagate to the child dialog and automatically close it
 * Needs to be used with dialogUtils.showCustomDialog() method where keyboardSetting is set to false
 */
export class CustomKeysDialog extends SimpleDialog<SimpleDialogModel> {
	public activate(model: SimpleDialogModel): Promise<SimpleDialogModel> {
		return super.activate(model).then(() => {
			this.model.dialogSize = SimpleDialog.DialogSize.EXTRA_SMALL;
			return this.model;
		});
	}
}
